import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { SubscriptionWInstance } from '../subscription-management/subscription-management.component';
import { EmailValidation } from 'src/app/model/EmailValidation';
import { FormControl, Validators } from '@angular/forms';
import { AdvancedSettings } from '../subscription-information/subscription-information.component';
import { CUTimeSlots, CuSubscriptionSlots } from 'src/app/model/TimeSlots';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { AppSubscription, CompanyInfoValues } from 'src/app/model/subscription';
import { cloneDeep } from 'lodash';
import { ModelService } from 'src/app/core/services/model.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IupService } from 'src/app/core/services/IupService';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { OperationResult } from '@tb/auth';
import { debounceTime } from 'rxjs/operators';
import { CmsService } from 'src/app/core/services/cms.service';
import { MiGenParameters } from 'src/app/model/MiGenParameters';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';

@Component({
    selector: 'ms-advanced-settings',
    templateUrl: './advanced-settings.component.html',
    styleUrls: ['./advanced-settings.component.scss'],
})
export class AdvancedSettingsComponent implements OnInit {
    subtitle_1: string;
    subtitle_2: string;
    advancedSettingsSubtitle: string;
    advancedSettingsUpdateTitle: string;
    advancedSettingsUpdateSubTitle: string;
    textExistingCalendar: string;
    timeSlotChoice: string;
    copyOfTimeSlotChoice: string;
    copyOfNote: string;
    mw_subtitle_1: string;
    mw_subtitle_2: string;
    message: string;
    showEdit = false;
    ccEmail = false;
    bccEmail = false;
    ccEmailChecked = false;
    bccEmailChecked = false;
    showNoteInput = false;
    isComponentInitialized = false;
    sectionIsDisabled = false;
    alreadyChooseSlot = false;
    languageIsItalian = false;
    showTextExistingCalendar = false;
    isNotModified_1 = true;
    isNotModified_2 = true;
    isNotModified_3 = true;
    disableSaveButton = true;
    disableCancelButton = true;
    countForNoteInput = 0;
    emailControl: FormControl;
    ccEmailControl: FormControl;
    bccEmailControl: FormControl;
    noteControl: FormControl;
    emailEntity: EmailValidation;
    copyEmailEntity: EmailValidation;
    timeSlots: CUTimeSlots[] = [];
    infoSlot: CuSubscriptionSlots;
    @ViewChildren('noteInput') _noteInput: QueryList<any>;
    @Input() subscription: SubscriptionWInstance;
    @Input() model: AppSubscription;
    @Input() copyOfModel: AppSubscription;
    @Input() advancedSettings: AdvancedSettings;
    @Input() copyOfAdvancedSettings: AdvancedSettings;
    @Input() isNotInternal: boolean;
    @Input() isDevOpsOrSysAdmin: boolean;
    @Input() showAdvancedSettings: boolean;
    @Input() showEmailSection: boolean;
    @Input() existsAuditing: boolean;
    @Input() existsSecurity: boolean;
    @Input() existsVisibility: boolean;
    @Input() existsCGM: boolean;
    @Input() isMoving: boolean;
    @Input() currentsubscriptionKey: string;
    @Input() language: string;
    @Input() productID: string;
    @Output() descriptionChanged = new EventEmitter<AppSubscription>();
    @Output() closeDrawer = new EventEmitter();

    constructor(
        private modelService: ModelService,
        private workFlow: WorkFlowService,
        private iupService: IupService,
        private subscriptionService: SubscriptionService,
        private cmsService: CmsService,
        private variable: TranslatedVariables,
        private cd: ChangeDetectorRef,
        private serviceUtilsService: ServiceUtilsService
    ) {
        this.emailEntity = new EmailValidation();
        this.copyEmailEntity = new EmailValidation();
        this.emailControl = new FormControl(this.emailEntity.Email, [Validators.required, Validators.email, Validators.maxLength(254)]);
        this.ccEmailControl = new FormControl(this.emailEntity.Cc, [Validators.email, Validators.maxLength(254)]);
        this.bccEmailControl = new FormControl(this.emailEntity.Bcc, [Validators.email, Validators.maxLength(254)]);
        this.bccEmailControl = new FormControl(this.emailEntity.Bcc, [Validators.email, Validators.maxLength(254)]);
        this.noteControl = new FormControl('', [Validators.maxLength(254)]);
    }
    async ngOnChanges() {
        // Check to avoid the execution of this code multiple time but just when we move from a subscription to another
        if (
            this.isComponentInitialized &&
            this.isMoving &&
            this.copyOfModel.SubscriptionKey === this.model.SubscriptionKey &&
            this.copyOfModel.SubscriptionKey !== this.currentsubscriptionKey
        ) {
            if (!this.sectionIsDisabled && this.productID !== 'MW') {
                this.timeSlotChoice = undefined;
                this.copyOfTimeSlotChoice = undefined;
                this.noteControl.setValue('');
                this.copyOfNote = '';
                this.getTimeSlotsReactive();
            }
            await this.getEmailAssociatedToSubkey(this.currentsubscriptionKey);
            // Is really necessary calling the function restore ?
            this.restore();
        }
    }

    ngDoCheck() {
        if (this.isComponentInitialized && !this.sectionIsDisabled && this.productID !== 'MW') {
            this._noteInput.changes.subscribe(() => {
                if (this._noteInput.first && this.countForNoteInput === 0) {
                    this.countForNoteInput++;
                    this._noteInput.first.nativeElement.focus();
                    this.cd.detectChanges();
                }
            });
        }
    }

    async ngOnInit() {
        this.languageIsItalian = this.workFlow.languageIsItalian() ? true : false;
        let opRes: OperationResult = await this.serviceUtilsService.getStoreParameterValue('timeSlots');
        let content = new MiGenParameters();
        content = opRes.Content as MiGenParameters;
        this.sectionIsDisabled = content.Disabled;
        if (!this.sectionIsDisabled && this.productID !== 'MW') {
            this.getTimeSlotsReactive();
        }
        await this.getEmailAssociatedToSubkey(this.currentsubscriptionKey);
        this.emailControl.valueChanges.pipe(debounceTime(1000)).subscribe(async (res) => {
            if (this.emailEntity.Email === '') {
                this.emailEntity.EmailValidated = false;
                // this.loading = false;
                // this.loadingService.setLoading(this.loading);
                return;
            }
            if (this.emailEntity.SubscriptionKey !== this.currentsubscriptionKey) {
                await this.getEmailAssociatedToSubkey(this.currentsubscriptionKey);
            }
            this.isEmailValidated();
        });
        await this.getCmsObj();
        //se ha gia' la funzionalità attiva, allora la checkbox deve essere a true
        let checkedAuditing = this.copyOfModel.CompanyInfo?.length > 0 && this.copyOfModel.CompanyInfo.includes(CompanyInfoValues.auditing);
        let checkedVisibility =
            this.copyOfModel.CompanyInfo?.length > 0 && this.copyOfModel.CompanyInfo.includes(CompanyInfoValues.visibility);
        let checkedSecurity = this.copyOfModel.CompanyInfo?.length > 0 && this.copyOfModel.CompanyInfo.includes(CompanyInfoValues.security);
        let checkedCGM = this.copyOfModel.CompanyInfo?.length > 0 && this.copyOfModel.CompanyInfo.includes(CompanyInfoValues.CGM);
        //C'è qualche problema con il puntamento di queste 2 variabili perchè la copia viene sempre compromessa in modifica
        this.advancedSettings.assign(checkedVisibility, checkedSecurity, checkedCGM, checkedAuditing);
        this.copyOfAdvancedSettings = cloneDeep(this.advancedSettings);
        this.isComponentInitialized = true;
    }

    async getEmailAssociatedToSubkey(subKey: string) {
        let opRes = await this.modelService.getSubsEmailToPromise(subKey);
        if (!opRes.Result) {
            // nessun messaggio, non ci sono subscription, amen
            this.emailEntity = new EmailValidation();
            if (this.emailEntity.Email === null || this.emailEntity.Email === '') this.modifyContent(true);
            this.emailEntity.SubscriptionKey = subKey;
            this.emailControl = new FormControl(this.emailEntity.Email, [Validators.required, Validators.email, Validators.maxLength(254)]);
            this.copyEmailEntity = cloneDeep(this.emailEntity);
            // this.loading = false;
            // this.loadingService.setLoading(this.loading);
            return;
        }
        this.emailEntity = opRes.Content;
        this.copyEmailEntity = cloneDeep(this.emailEntity);
        this.emailControl = new FormControl(this.emailEntity.Email, [Validators.required, Validators.email, Validators.maxLength(254)]);
        this.setToggles();
        if (this.emailEntity.Email === null || this.emailEntity.Email === '') this.modifyContent(true);
        if (this.isMoving) {
            this.closeDrawer.emit();
        }
    }

    async getCmsObj() {
        //recupero le stringhe della pagina
        let cmsObj = await this.cmsService.getCmsObj(this.language, 'emailvalidation');
        this.subtitle_1 = cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_1').ContentTranslation;
        this.subtitle_2 = cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_2').ContentTranslation;
        this.mw_subtitle_1 = cmsObj.find((x) => x.ContentName == 'emailvalidation.mw_subtitle_1').ContentTranslation;
        this.mw_subtitle_2 = cmsObj.find((x) => x.ContentName == 'emailvalidation.mw_subtitle_2').ContentTranslation;
        cmsObj = await this.cmsService.getCmsObj(this.language, 'store');
        this.advancedSettingsSubtitle = cmsObj.find((x) => x.ContentName == 'store.advancedSettingsSubtitle').ContentTranslation;
        if (!this.sectionIsDisabled) {
            this.advancedSettingsUpdateTitle = cmsObj.find((x) => x.ContentName == 'store.advancedSettingsUpdateTitle').ContentTranslation;
            this.advancedSettingsUpdateSubTitle = cmsObj.find(
                (x) => x.ContentName == 'store.advancedSettingsUpdateSubTitle'
            ).ContentTranslation;
        }
    }

    setEmails(value: any, mail: string) {
        if (mail === 'cc') {
            this.ccEmailChecked = value;
            if (!this.ccEmailChecked) {
                this.emailEntity.Cc = '';
                this.ccEmailControl.setValue('');
            }
        } else {
            this.bccEmailChecked = value;
            if (!this.bccEmailChecked) {
                this.emailEntity.Bcc = '';
                this.bccEmailControl.setValue('');
            }
        }
        this.emailParamsChanged();
    }

    emailParamsChanged() {
        this.isNotModified_1 =
            this.emailEntity.Email === this.copyEmailEntity.Email &&
            this.emailEntity.Bcc === this.copyEmailEntity.Bcc &&
            this.emailEntity.Cc === this.copyEmailEntity.Cc;
        this.somethingChanged();
    }

    somethingChanged() {
        // disabilita SaveButton se = (non è stato modificato nulla nè sopra nè sotto) oppure (se c'è anche solo un campo invalido) oppure (se è stata inserita la mail report@mago.cloud e non si è nè internal nè devops)
        let hasNoRights =
            this.isNotInternal === true &&
            this.isDevOpsOrSysAdmin === false &&
            (this.emailControl.value === 'report@mago.cloud' ||
                this.bccEmailControl.value === 'report@mago.cloud' ||
                this.ccEmailControl.value === 'report@mago.cloud');
        let nothingModified = this.isNotModified_1 && this.isNotModified_2 && this.isNotModified_3;
        let emailsInvalid = this.emailControl.invalid || this.bccEmailControl.invalid || this.ccEmailControl.invalid;
        // se la email è invalida evidenziare di più il fatto che non può salvare le info se non c'è una email valida
        this.disableSaveButton = nothingModified || emailsInvalid || hasNoRights;
        // disabilita CancelButton se = (non è stato modificato nulla nè sopra nè sotto) e il campo email non è vuoto ( e quindi la showEdit è false)
        this.disableCancelButton = nothingModified;
        if (this.emailEntity.Email !== '' && this.emailEntity.Email !== undefined)
            this.disableCancelButton = this.disableCancelButton && !this.showEdit;
    }

    setAdvancedSettings(value: boolean, parameter: string) {
        switch (parameter) {
            case 'AUDITING':
                this.advancedSettings.CheckedAuditing = value;
                this.setCompanyInfo(this.advancedSettings.CheckedAuditing, CompanyInfoValues.auditing);
                break;
            case 'VISIBILITY':
                this.advancedSettings.CheckedVisibility = value;
                this.setCompanyInfo(this.advancedSettings.CheckedVisibility, CompanyInfoValues.visibility);
                break;
            case 'SECURITY':
                this.advancedSettings.CheckedSecurity = value;
                this.setCompanyInfo(this.advancedSettings.CheckedSecurity, CompanyInfoValues.security);
                break;
            case 'CGM':
                this.advancedSettings.CheckedCGM = value;
                this.setCompanyInfo(this.advancedSettings.CheckedCGM, CompanyInfoValues.CGM);
                break;
        }
        this.somethingChanged();
    }

    setCompanyInfo(checked: boolean, parameter: string) {
        if (checked) {
            if (this.model.CompanyInfo) {
                this.model.CompanyInfo += `,${parameter}`;
            } else {
                this.model.CompanyInfo = parameter;
            }
        } else {
            if (this.model.CompanyInfo.length !== parameter.length) {
                let copy = this.model.CompanyInfo;
                this.model.CompanyInfo = this.model.CompanyInfo.replace(`,${parameter}`, '');
                if (copy === this.model.CompanyInfo) {
                    this.model.CompanyInfo = this.model.CompanyInfo.replace(`${parameter},`, '');
                }
            } else {
                this.model.CompanyInfo = this.model.CompanyInfo.replace(parameter, '');
            }
        }
        this.isNotModified_2 = this.copyOfModel.CompanyInfo === this.model.CompanyInfo;
    }

    save() {
        // Possible combos
        if (!this.isNotModified_1 && !this.isNotModified_2 && !this.isNotModified_3) {
            // Save advanced settings + time slots + e-mail
            this.submitMpEmail();
            this.submitSubscription();
            this.saveTimeSlots();
            return;
        } else if (!this.isNotModified_1 && !this.isNotModified_2) {
            // Save e-mail + advanced settings
            this.submitMpEmail();
            this.submitSubscription();
            return;
        } else if (!this.isNotModified_1 && !this.isNotModified_3) {
            // Save e-mail + time slots
            this.submitMpEmail();
            this.saveTimeSlots();
            return;
        } else if (!this.isNotModified_2 && !this.isNotModified_3) {
            // Save advanced settings + time slots
            this.submitSubscription();
            this.saveTimeSlots();
            return;
        } else if (!this.isNotModified_1) {
            // Save e-mail
            this.submitMpEmail();
            return;
        } else if (!this.isNotModified_2) {
            // Save advanced settings
            this.submitSubscription();
            return;
        } else if (!this.isNotModified_3) {
            // Save time slots
            this.saveTimeSlots();
            return;
        }
    }

    submitMpEmail() {
        if (this.emailEntity === undefined || this.emailEntity.SubscriptionKey === undefined || this.emailEntity.SubscriptionKey === '') {
            this.workFlow.showMessage(this.variable.warningTitle, this.variable.dialogSubTitle_8);
            return;
        }

        this.emailEntity.SubscriptionKey = this.model.SubscriptionKey;

        this.modelService.saveMpEmail(this.emailEntity).subscribe(
            (emaiLSaveResult: { Result: any; Message: string }) => {
                if (!emaiLSaveResult.Result) {
                    this.workFlow.showMessage(this.variable.warningTitle, emaiLSaveResult.Message);
                    return;
                } else {
                    this.isEmailValidated();
                    this.setToggles();
                    this.copyEmailEntity = cloneDeep(this.emailEntity);
                    this.disableSaveButton = true;
                    this.disableCancelButton = true;
                    this.isNotModified_1 = true;
                    this.isNotModified_2 = true;
                    this.isNotModified_3 = true;
                    this.showEdit = false;
                    this.workFlow.showMessage(this.variable.configuration, this.variable.operationSucceeded);
                }
            },
            (err: { message: string }) => {
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
                return;
            }
        );
    }

    isEmailValidated() {
        if (this.emailEntity.Email === '' || this.emailEntity.Email === null || this.emailEntity.Email === undefined) {
            this.workFlow.showSnackBar(this.variable.warningTitle, this.variable.commonsEmailNotValid);
            return;
        }
        const emailIsValidated = this.modelService.getEmailIsValidated(this.emailEntity.Email, this.currentsubscriptionKey).subscribe(
            (res) => {
                let object: EmailValidation = res.Content;
                this.emailEntity.EmailValidated = object.EmailValidated ? object.EmailValidated : false;
                emailIsValidated.unsubscribe();
                if (!res.Result && res.Code !== 16) this.workFlow.showSnackBar(this.variable.warningTitle, res.Message);
            },
            (err) => {
                this.emailEntity.EmailValidated = false;
                this.workFlow.showSnackBar(this.variable.warningTitle, err.message);
                emailIsValidated.unsubscribe();
            }
        );
    }

    submitSubscription() {
        if (this.model === undefined || this.model.SubscriptionKey === undefined) {
            this.workFlow.showMessage(this.variable.warningTitle, this.variable.dialogSubTitle_8);
            return;
        }
        this.subscriptionService.saveSubscription(this.model).subscribe(
            (subscriptionResult) => {
                if (!subscriptionResult.Result) {
                    this.workFlow.showSnackBar(this.variable.operationFailed, subscriptionResult.Message);
                    return;
                }
                this.copyOfModel = new AppSubscription();
                this.copyOfModel.assign(this.model);
                this.descriptionChanged.emit(this.model);
                this.disableSaveButton = true;
                this.isNotModified_1 = true;
                this.isNotModified_2 = true;
                this.isNotModified_3 = true;
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
            },
            (err) => {
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
            }
        );
    }

    // Questa parte è ancora necessaria nelle configurazioni avanzate ?
    saveTimeSlots() {
        let subscriptionSlots: CuSubscriptionSlots = new CuSubscriptionSlots();
        subscriptionSlots.ranking = this.infoSlot.ranking;
        subscriptionSlots.subscriptionkey = this.currentsubscriptionKey;
        subscriptionSlots.timeslotnote = this.noteControl.value;
        this.iupService.saveTimeSlotsReactive(subscriptionSlots).subscribe(
            (res: OperationResult) => {
                if (!res.Result) {
                    this.workFlow.showMessage(this.variable.warningTitle, res.Message);
                    return;
                }
                if (this.noteControl.value !== this.copyOfNote) {
                    this.showNoteInput = false;
                    this.copyOfNote = cloneDeep(this.noteControl.value);
                }
                this.copyOfTimeSlotChoice = cloneDeep(this.timeSlotChoice);
                this.disableSaveButton = true;
                this.disableCancelButton = true;
                this.isNotModified_1 = true;
                this.isNotModified_2 = true;
                this.isNotModified_3 = true;
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
            },
            (err) => {
                this.workFlow.showMessage(this.variable.warningTitle, err.message);
            }
        );
    }

    restore() {
        this.isNotModified_1 = true;
        this.isNotModified_2 = true;
        this.isNotModified_3 = true;
        this.advancedSettings = this.copyOfAdvancedSettings;
        this.emailControl.setValue(this.copyEmailEntity.Email);
        this.emailEntity = cloneDeep(this.copyEmailEntity);
        this.bccEmailControl.setValue(this.copyEmailEntity.Bcc);
        this.ccEmailControl.setValue(this.copyEmailEntity.Cc);
        this.noteControl.setValue(this.copyOfNote);
        this.showEdit = this.emailEntity.Email === null || this.emailEntity.Email === '';
        this.timeSlotChoice = this.copyOfTimeSlotChoice;
        this.somethingChanged();
        this.setToggles();
        this.showNoteInput = false;
        this.countForNoteInput = 0;
    }

    setToggles() {
        this.bccEmailChecked = this.emailEntity.Bcc && this.emailEntity.Bcc.length !== 0 ? true : false;
        this.ccEmailChecked = this.emailEntity.Cc && this.emailEntity.Cc.length !== 0 ? true : false;
    }

    onEditNote() {
        this.showNoteInput = true;
        this.disableCancelButton = false;
    }

    onValueChange(index: number) {
        this.timeSlotChoice = this.timeSlots[index].timeslotstart;
        this.isNotModified_3 = this.timeSlotChoice === this.copyOfTimeSlotChoice && this.noteControl.value === this.copyOfNote;
        this.somethingChanged();
    }

    modifyContent(editMail: boolean) {
        this.showEdit = editMail;
    }

    getTimeSlotsReactive() {
        this.iupService.getTimeSlotsReactive(this.currentsubscriptionKey).subscribe(
            (res: OperationResult) => {
                if (!res.Result) {
                    this.message = this.languageIsItalian
                        ? 'Errore nella chiamata getTimeSlotsReactive'
                        : 'Error calling getTimeSlotsReactive';
                    this.workFlow.showMessage(this.variable.warningTitle, this.message);
                    this.sectionIsDisabled = true;
                    return;
                }
                this.timeSlots = res.Content;
                this.timeSlots.forEach(function (element) {
                    element.timeslotstart = element.timeslotstart.slice(0, -3);
                    let timeSplit = element.timeslotstart.split(':');
                    // da rivedere perchè nel caso in cui una fascia oraria fosse a mezzanotte cosa fare ? verrà fatto un 24 + 1 che non va bene
                    if (timeSplit[1] === '30') {
                        element.timeslotend = `${+timeSplit[0] + 1}:00`;
                    } else {
                        element.timeslotend = `${timeSplit[0]}:${+timeSplit[1] + 30}`;
                    }
                });
                this.timeSlots.sort((a, b) => a.timeslotid - b.timeslotid);
                this.getCalendarJobs();
                this.noteControl.valueChanges.pipe(debounceTime(1000)).subscribe(async (res) => {
                    this.isNotModified_3 = this.timeSlotChoice === this.copyOfTimeSlotChoice && this.noteControl.value === this.copyOfNote;
                    this.somethingChanged();
                });
            },
            (err) => {
                this.message = this.languageIsItalian ? 'Errore nella chiamata getTimeSlotsReactive' : 'Error calling getTimeSlotsReactive';
                this.workFlow.showMessage(this.variable.warningTitle, this.message);
                this.sectionIsDisabled = true;
            }
        );
    }

    getSubscriptionSlotReactive() {
        this.iupService.getSubscriptionSlotReactive(this.currentsubscriptionKey).subscribe(
            (res: OperationResult) => {
                if (!res.Result) {
                    this.message = this.languageIsItalian
                        ? 'Errore nella chiamata getSubscriptionSlotReactive'
                        : 'Error calling getSubscriptionSlotReactive';
                    this.workFlow.showMessage(this.variable.warningTitle, this.message);
                    this.sectionIsDisabled = true;
                    this.alreadyChooseSlot = false;
                    return;
                }
                if (Object.keys(res.Content).length !== 0) {
                    this.infoSlot = res.Content;
                    // DA RIMUOVERE PERCHè NON SERVE PIù
                    // this.timeSlotChoice = this.timeSlots.filter((x) => x.timeslotid === this.infoSlot.timeslotid)[0].timeslotstart;
                    // this.copyOfTimeSlotChoice = this.timeSlots.filter((x) => x.timeslotid === this.infoSlot.timeslotid)[0].timeslotstart;
                    this.noteControl.setValue(this.infoSlot.timeslotnote);
                    this.copyOfNote = cloneDeep(this.noteControl.value);
                    this.alreadyChooseSlot = true;
                } else {
                    this.alreadyChooseSlot = false;
                }
                this.sectionIsDisabled = false;
            },
            (err) => {
                this.message = this.languageIsItalian
                    ? 'Errore nella chiamata getSubscriptionSlotReactive'
                    : 'Error calling getSubscriptionSlotReactive';
                this.workFlow.showMessage(this.variable.warningTitle, this.message);
                this.sectionIsDisabled = true;
            }
        );
    }

    getCalendarJobs() {
        this.iupService.getCalendarJobs(this.currentsubscriptionKey).subscribe(
            (res: OperationResult) => {
                if (!res.Result) {
                    this.message = this.languageIsItalian ? 'Errore nella chiamata getCalendarJobs' : 'Error calling getCalendarJobs';
                    this.workFlow.showMessage(this.variable.warningTitle, this.message);
                    this.showTextExistingCalendar = false;
                    this.sectionIsDisabled = true;
                    return;
                }
                if (Object.keys(res.Content).length !== 0) {
                    this.showTextExistingCalendar = true;
                    let date = new Date(res.Content.scheduledtime);
                    let timeSlotChosen = this.timeSlots.find((element) => element.timeslotid === res.Content.timeslotid);
                    // Adding "+1" to the month is because the month start with index 0 so if the month is genuary the function getMonth() without the "+1" will return 0 instead of 1;
                    let scheduledDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                    this.textExistingCalendar = this.languageIsItalian
                        ? `Per la tua subscription è già stato programmato un aggiornamento di prodotto in data ${scheduledDate}  nella fascia da te scelta ${timeSlotChosen.timeslotstart} - ${timeSlotChosen.timeslotend} <br> In caso di modifica della fascia oraria, essa avrà effetto dall'aggiornamento successivo.`
                        : `A product update has already been scheduled for your subscription on ${scheduledDate} in the slot you have chosen ${timeSlotChosen.timeslotstart} - ${timeSlotChosen.timeslotend} <br> If the time slot is changed, it will take effect from the next update.`;
                } else {
                    this.showTextExistingCalendar = false;
                }
                this.getSubscriptionSlotReactive();
            },
            (err) => {
                this.message = this.languageIsItalian ? 'Errore nella chiamata getCalendarJobs' : 'Error calling getCalendarJobs';
                this.workFlow.showMessage(this.variable.warningTitle, this.message);
                this.showTextExistingCalendar = false;
                this.sectionIsDisabled = true;
            }
        );
    }

    getErrorMessage() {
        return this.emailControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.emailControl.hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.emailControl.hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.ccEmailControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.ccEmailControl.hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.ccEmailControl.hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.bccEmailControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.bccEmailControl.hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.bccEmailControl.hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.noteControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.noteControl.hasError('maxlength')
            ? this.variable.commonsMaxLength
            : '';
    }
}
